import { useScanDeviceApiDetailQuery } from '@hooks/api/useScanDeviceApiDetailQuery';
import type { DeepScanVersion } from 'types/api';

export const useDeepScanVersion =
  useScanDeviceApiDetailQuery<DeepScanVersion>('/deepscan-versions');
